import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import { useContext, useEffect, useState } from "react";
import SchwingLogo from "../../../Images/Machines/Batching plant.png";
import dayjs from "dayjs";

import SchwingLogoIndia from "../../../Images/Machines/Batching plant.png";

const tableHeadings = [
  {
    b_no: "Batch No",
    st: "Start Date",
    et: "End Date",
    trk: "Truck",
    dver: "Driver",
    o_id: "Operator Id",
    c_id: "Cust Id",
    site: "Site",
    rec_id: "Recp Id",
    rec_name: "Recp Name",
    qty: "Qty",
  },
];

const ConsolidatedReport = ({ reportData, from, to }) => {
  const [pdfUrlCh, setPdfUrlCh] = useState(null);

  async function handleGeneratePDF() {
    const pdfDoc = await PDFDocument.create();
    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const schwingIndia = "Schwing India";
    const fontSize = 8.5;
    const pageWidth = 850;
    const pageHeight = 842;
    const title = "Company Name";
    const fromDate = dayjs(from).format("DD-MM-YYYY");
    const toDate = dayjs(to).format("DD-MM-YYYY");

    const data = [];
    for (let y in reportData.data) {
      data.push(reportData.data[y]);
    }

    const x = 10;
    const y = pageHeight - (tableHeadings.length - 2) * fontSize;

    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const pageCount = Math.ceil(data.length / 15);
    let rowY = pageHeight - (tableHeadings.length - 2) * fontSize;
    let rowY2 = y;
    const imageBytes = await fetch(SchwingLogo).then((res) =>
      res.arrayBuffer()
    );

    const image = await pdfDoc.embedPng(imageBytes);

    const imageBytes1 = await fetch(SchwingLogoIndia).then((res) =>
      res.arrayBuffer()
    );

    const image1 = await pdfDoc.embedPng(imageBytes1);
    let logo;

    // try {
    //   const imageUrl = sessionStorage.getItem("logoImageUrl"); // Get the image from sessionStorage

    //   if (!imageUrl)
    //     throw new Error("No image URL available in sessionStorage");

    //   const imageBytes = await fetch(imageUrl).then((res) => res.arrayBuffer());

    //   // Embed image based on its format
    //   if (imageUrl.includes("png")) {
    //     logo = await pdfDoc.embedPng(imageBytes);
    //   } else if (imageUrl.includes("jpeg") || imageUrl.includes("jpg")) {
    //     logo = await pdfDoc.embedJpg(imageBytes);
    //   } else {
    //     throw new Error(
    //       "Unsupported image format. Only PNG and JPG are allowed."
    //     );
    //   }
    // } catch (error) {
    //   console.error("Error embedding logo:", error);
    // }

    for (let i = 0; i < pageCount; i++) {
      const startIndex = i * 16;
      const endIndex = Math.min(startIndex + 16, data.length); //sets how many rows should be rendered in one page
      const pageData = data.slice(startIndex, endIndex);

      if (pageData.length > 0) {
        //only if there is data the pdf will be generated
        rowY = 695;
        let page = pdfDoc.addPage([pageWidth, pageHeight]);
        let pageRowY = rowY;

        for (const element of pageData) {
          const fontSize = 8.5;
          const lineSpacing = fontSize + 4;
          const textPadding = 2;

          // Site field (wrap)
          const maxWidthSite = 90;
          const textSite = element.site.toString();
          const wordsSite = textSite.split(" ");
          let linesSite = [];
          let currentLineSite = "";

          for (let word of wordsSite) {
            const testLine = currentLineSite
              ? currentLineSite + " " + word
              : word;
            const testWidth = font.widthOfTextAtSize(testLine, fontSize);
            if (testWidth <= maxWidthSite) {
              currentLineSite = testLine;
            } else {
              linesSite.push(currentLineSite);
              currentLineSite = word;
            }
          }
          if (currentLineSite) linesSite.push(currentLineSite);

          // rec_name field (wrap)
          const maxWidthRecName = 80;
          const textRecName = element.rec_name.toString();
          const wordsRecName = textRecName.split(" ");
          let linesRecName = [];
          let currentLineRecName = "";

          for (let word of wordsRecName) {
            const testLine = currentLineRecName
              ? currentLineRecName + " " + word
              : word;
            const testWidth = font.widthOfTextAtSize(testLine, fontSize);
            if (testWidth <= maxWidthRecName) {
              currentLineRecName = testLine;
            } else {
              linesRecName.push(currentLineRecName);
              currentLineRecName = word;
            }
          }
          if (currentLineRecName) linesRecName.push(currentLineRecName);

          const maxWidthCId = 50;
          const textCId = element.c_id.toString();
          const wordsCId = textCId.split(" ");
          let linesCId = [];
          let currentLineCId = "";

          for (let word of wordsCId) {
            const testLine = currentLineCId
              ? currentLineCId + " " + word
              : word;
            const testWidth = font.widthOfTextAtSize(testLine, fontSize);

            if (testWidth <= maxWidthCId) {
              currentLineCId = testLine;
            } else {
              if (currentLineCId) {
                linesCId.push(currentLineCId);
              }
              // Check if word itself is longer than maxWidth
              const wordWidth = font.widthOfTextAtSize(word, fontSize);
              if (wordWidth <= maxWidthCId) {
                currentLineCId = word;
              } else {
                // Break long word character-by-character
                let splitWord = "";
                for (let char of word) {
                  const testSplit = splitWord + char;
                  if (
                    font.widthOfTextAtSize(testSplit, fontSize) <= maxWidthCId
                  ) {
                    splitWord = testSplit;
                  } else {
                    linesCId.push(splitWord);
                    splitWord = char;
                  }
                }
                currentLineCId = splitWord;
              }
            }
          }

          if (currentLineCId) linesCId.push(currentLineCId);

          // Calculate the number of lines needed for the row
          const lineCount = Math.max(
            linesSite.length,
            linesRecName.length,
            linesCId.length
          );
          const rowHeight = lineCount * lineSpacing;

          // Draw fixed fields
          page.drawText(element.b_no.toString(), {
            x: x + 15,
            y: pageRowY - 5,
            font,
            size: fontSize,
          });
          page.drawText(element.st.toString(), {
            x: x + 70,
            y: pageRowY - 5,
            font,
            size: fontSize,
          });
          page.drawText(element.et.toString(), {
            x: x + 160,
            y: pageRowY - 5,
            font,
            size: fontSize,
          });
          page.drawText(element.trk.toString(), {
            x: x + 250,
            y: pageRowY - 5,
            font,
            size: fontSize,
          });
          page.drawText(element.dver.toString(), {
            x: x + 320,
            y: pageRowY - 5,
            font,
            size: fontSize,
          });
          page.drawText(element.o_id.toString(), {
            x: x + 400,
            y: pageRowY - 5,
            font,
            size: fontSize,
          });
          linesCId.forEach((line, index) => {
            page.drawText(line, {
              x: x + 480,
              y: pageRowY - 5 - index * lineSpacing,
              font,
              size: fontSize,
            });
          });
          // Draw wrapped Site
          linesSite.forEach((line, index) => {
            page.drawText(line, {
              x: x + 535,
              y: pageRowY - 5 - index * lineSpacing,
              font,
              size: fontSize,
            });
          });

          // rec_id
          page.drawText(element.rec_id.toString(), {
            x: x + 650,
            y: pageRowY - 5,
            font,
            size: fontSize,
          });

          // Draw wrapped rec_name
          linesRecName.forEach((line, index) => {
            page.drawText(line, {
              x: x + 700,
              y: pageRowY - 5 - index * lineSpacing,
              font,
              size: fontSize,
            });
          });

          // qty
          page.drawText(element.qty.toString(), {
            x: x + 780,
            y: pageRowY - 5,
            font,
            size: fontSize,
          });

          // Draw line under the whole row (after the tallest field)
          page.drawLine({
            start: { x: 10, y: pageRowY - rowHeight - textPadding },
            end: {
              x: pageWidth - 10,
              y: pageRowY - rowHeight - textPadding,
            },
            thickness: 0.5,
            color: rgb(0.8, 0.8, 0.8),
          });

          // Move Y for next row
          pageRowY -= rowHeight + 10; // add some spacing between rows
        }

        if (endIndex === data.length) {
          let additionalRowY = Math.max(pageRowY);
          let total = 0;
          data.forEach((element) => {
            total += parseFloat(element.qty);
          });
        }
        page.drawText("Consolidated Report", {
          x: 335,
          y: 775,
          size: 14,
          font,
        });
        page.drawText("Plant Sl No.:", {
          x: 25,
          y: 757,
          size: 12,
          font,
        });
        page.drawText(
          reportData.plant_sl ? reportData.plant_sl.toString() : "N/A",
          {
            x: 105,
            y: 757,
            size: 12,
            font,
          }
        );
        page.drawText("Plant Name:", {
          x: 25,
          y: 740,
          size: 12,
          font,
        });
        page.drawText(
          reportData.plant_type ? reportData.plant_type.toString() : "N/A",
          {
            x: 105,
            y: 740,
            size: 12,
            font,
          }
        );
        page.drawText("From Time:", {
          x: 680,
          y: 757,
          size: 12,
          font,
        });
        page.drawText(fromDate.toString(), {
          x: 750,
          y: 757,
          size: 12,
          font,
        });
        page.drawText("To Time:", {
          x: 680,
          y: 740,
          size: 12,
          font,
        });
        page.drawText(toDate.toString(), {
          x: 750,
          y: 740,
          size: 12,
          font,
        });
        tableHeadings &&
          tableHeadings.forEach((header, rowIndex) => {
            rowY2 = y - (rowIndex + 16) * fontSize;

            page.drawText(header.b_no.toString(), {
              x: x + 15,
              y: rowY2,
              font: boldFont,
              size: fontSize + 2,
            });
            page.drawText(header.st.toString(), {
              x: x + 70,
              y: rowY2,
              font: boldFont,
              size: fontSize + 2,
            });
            page.drawText(header.et.toString(), {
              x: x + 160,
              y: rowY2,
              font: boldFont,
              size: fontSize + 2,
            });
            page.drawText(header.trk.toString(), {
              x: x + 250,
              y: rowY2,
              font: boldFont,
              size: fontSize + 2,
            });
            page.drawText(header.dver.toString(), {
              x: x + 320,
              y: rowY2,
              font: boldFont,
              size: fontSize + 2,
            });
            page.drawText(header.o_id.toString(), {
              x: x + 400,
              y: rowY2,
              font: boldFont,
              size: fontSize + 2,
            });
            page.drawText(header.c_id.toString(), {
              x: x + 480,
              y: rowY2,
              font: boldFont,
              size: fontSize + 2,
            });
            page.drawText(header.site.toString(), {
              x: x + 535,
              y: rowY2,
              font: boldFont,
              size: fontSize + 2,
            });
            page.drawText(header.rec_id.toString(), {
              x: x + 650,
              y: rowY2,
              font: boldFont,
              size: fontSize + 2,
            });
            page.drawText(header.rec_name.toString(), {
              x: x + 700,
              y: rowY2,
              font: boldFont,
              size: fontSize + 2,
            });
            page.drawText(header.qty.toString(), {
              x: x + 780,
              y: rowY2,
              font: boldFont,
              size: fontSize + 2,
            });
            // 🔽 Draw line below header
            page.drawLine({
              start: { x: 10, y: rowY2 - 5 }, // small gap below text
              end: { x: pageWidth - 10, y: rowY2 - 5 },
              thickness: 1,
              color: rgb(0, 0, 0), // black line
            });
          });

        page.drawText(title, {
          x: 280,
          y: 800,
          size: 18,
          font,
        });

        // if (sessionStorage.getItem("leftimage") === "1") {
        //   page.drawImage(image1, {
        //     x: 20,
        //     y: 790,
        //     width: 100,
        //     height: 40,
        //   });
        // } else {
        //   page.drawImage(image, {
        //     x: 20,
        //     y: 800,
        //     width: 100,
        //     height: 30,
        //   });
        // }

        // if (sessionStorage.getItem("footer") !== "") {
        //   const maxWidth = page.getWidth(); // Get the full page width
        //   const fontSize = 10;
        //   const footerText = sessionStorage.getItem("footer");
        //   const lineHeight = 12;

        //   // Calculate yPos for footer
        //   const yPos = 40;

        //   // Draw a full-width horizontal line above the footer
        //   page.drawLine({
        //     start: { x: 10, y: yPos + 15 }, // Start from left edge
        //     end: { x: maxWidth - 10, y: yPos + 15 }, // End at right edge
        //     thickness: 1,
        //     color: rgb(0, 0, 0), // Black line
        //   });

        //   // Draw the footer text
        //   page.drawText(footerText, {
        //     x: 30,
        //     y: yPos,
        //     size: fontSize,
        //     font: boldFont,
        //     maxWidth: maxWidth - 60, // Adjust to avoid text overflow
        //     lineHeight: lineHeight,
        //   });
        // }

        // if (sessionStorage.getItem("logo") === "1" && logo) {
        //   const imgDims = logo.scale(1); // gets native width & height in points

        //   const targetWidth = 60;
        //   const aspectRatio = imgDims.height / imgDims.width;
        //   const targetHeight = targetWidth * aspectRatio;

        //   page.drawImage(logo, {
        //     x: 690,
        //     y: 780,
        //     width: targetWidth,
        //     height: targetHeight,
        //   });
        // }
      }
    }

    // Save the PDF
    const pdfBytes = await pdfDoc.save();

    setPdfUrlCh(
      URL.createObjectURL(new Blob([pdfBytes], { type: "application/pdf" }))
    );
  }

  useEffect(() => {
    handleGeneratePDF();
  }, []);

  return (
    <Grid container spacing={2} alignItems='center'>
      <iframe
        src={pdfUrlCh}
        width='100%'
        height='600px'
        title='Batch Report PDF'
      />
    </Grid>
  );
};

export default ConsolidatedReport;
